import { SalesOrderAllocation } from './sales-order-allocation';

export interface SalesOrderAllocations {
  id: string;
  salesOrderAndLineNo: string;
  customerKey: string;
  customerName: string;
  productKey: string;
  productDescription: string;
  productType: string;
  allocations: SalesOrderAllocation[];
}
